'use strict';
var toLength = require('../internals/to-length');

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/length-of-array-like.js
// module id = 231
// module chunks = 0